// Instagram strip (sections/ht-instagram.liquid): muted autoplay of OUR reels over the cover photo.
// - One <video data-ht-reel> per post (rendered in the first copy of the doubled strip). It moves to whichever copy of the tile
//   is on screen, so the two copies never play together and ht.js's endless-loop jump (scrollLeft +/- half) never restarts it.
// - Plays only while its tile is on screen (IntersectionObserver), pauses off screen, max 2 at once, loops the first 12 s.
// - Nothing loads before that: preload="none", and the poster is set from the already loaded cover photo on the first play.
// - "Reduce motion", data saver, a blocked autoplay or a broken file = the cover photo stays (the <video> is invisible until it plays).
// Tap opens the post (the <video> ignores pointer events). Does not touch the drift / drag / fling / spin code in ht.js.
(() => {
  if (!('IntersectionObserver' in window)) return;
  const MAX = 2, LOOP_S = 12, START = 0.5, STOP = 0.15;   // start when half the tile is in view, stop when nearly gone
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const conn = navigator.connection;

  document.querySelectorAll('[data-ht-insta]').forEach((strip) => {
    const ratio = new Map();
    let blocked = false;
    const allowed = () => !blocked && !reduce.matches && !(conn && conn.saveData) && !document.hidden;

    const reels = [...strip.querySelectorAll('video[data-ht-reel]')].map((v) => {
      const key = v.dataset.htReel;
      const boxes = [...strip.querySelectorAll('[data-ht-reel-box]')].filter((b) => b.dataset.htReelBox === key);
      const r = { v, boxes, want: false, dead: false };
      v.muted = true; v.defaultMuted = true;
      v.addEventListener('timeupdate', () => { if (v.currentTime >= LOOP_S) v.currentTime = 0; });
      v.addEventListener('playing', () => { v.classList.add('is-on'); mark(r); });
      v.addEventListener('pause', () => mark(r));
      const last = v.querySelector('source:last-of-type');
      (last || v).addEventListener('error', () => { r.dead = true; r.want = false; v.classList.remove('is-on'); mark(r); });
      return r;
    }).filter((r) => r.boxes.length);
    if (!reels.length) return;

    const box = (r) => r.v.parentElement;
    const best = (r) => r.boxes.reduce((a, b) => ((ratio.get(b) || 0) > (ratio.get(a) || 0) ? b : a), r.boxes[0]);
    const mark = (r) => r.boxes.forEach((b) => b.classList.toggle('is-reel-playing', b === box(r) && !r.v.paused));
    const moveTo = (r, b) => {
      if (box(r) === b) return;
      const ref = b.querySelector('img') ? b.querySelector('img').nextSibling : b.firstChild;
      const was = !r.v.paused;
      if (b.moveBefore) b.moveBefore(r.v, ref); else b.insertBefore(r.v, ref);   // moveBefore keeps playback state as is
      if (was && r.v.paused) play(r);
      mark(r);
    };
    const play = (r) => {
      if (!r.v.poster) { const img = box(r).querySelector('img'); r.v.poster = (img && img.currentSrc) || r.v.dataset.poster || ''; }
      const p = r.v.play();
      if (p && p.catch) p.catch((e) => {
        if (e && e.name === 'NotAllowedError') { blocked = true; update(); }    // e.g. iOS low power mode: keep the photos
      });
    };

    const update = () => {
      const ok = allowed();
      reels.forEach((r) => {
        const seen = ratio.get(best(r)) || 0;
        if (r.want && (!ok || r.dead || seen < STOP)) r.want = false;
      });
      let n = reels.filter((r) => r.want).length;
      reels.filter((r) => !r.want && ok && !r.dead && (ratio.get(best(r)) || 0) >= START)
        .sort((a, b) => (ratio.get(best(b)) || 0) - (ratio.get(best(a)) || 0))
        .forEach((r) => { if (n < MAX) { r.want = true; n++; } });
      reels.forEach((r) => {
        if (r.want) {
          if ((ratio.get(box(r)) || 0) < STOP) moveTo(r, best(r));               // the other copy is the one on screen
          if (r.v.paused) play(r);
        } else if (!r.v.paused) r.v.pause();
      });
      guard();
    };

    // ht.js jumps scrollLeft by half the strip at the loop point (in its animation frame or after a fling settles). Move a
    // playing reel to its twin in the same frame, before paint, so the jump stays invisible (no flash of the cover photo).
    let lastX = null, guardOn = false;
    const tick = () => {
      if (!reels.some((r) => r.want)) { guardOn = false; lastX = null; return; }
      const x = strip.scrollLeft, half = strip.scrollWidth / 2;
      if (lastX !== null && half > 0 && Math.abs(x - lastX) > half / 2) {
        reels.forEach((r) => { if (r.want) { const twin = r.boxes.find((b) => b !== box(r)); if (twin) moveTo(r, twin); } });
      }
      lastX = x;
      requestAnimationFrame(tick);
    };
    const guard = () => { if (!guardOn && reels.some((r) => r.want)) { guardOn = true; requestAnimationFrame(tick); } };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => ratio.set(e.target, e.isIntersecting ? e.intersectionRatio : 0));
      update();
    }, { threshold: [0, STOP, START, 0.8, 1] });
    reels.forEach((r) => r.boxes.forEach((b) => io.observe(b)));

    document.addEventListener('visibilitychange', update);
    if (reduce.addEventListener) reduce.addEventListener('change', update);
    if (conn && conn.addEventListener) conn.addEventListener('change', update);
  });
})();
